
import styles from "../Startup/Choose.module.css";
import { Logo, ToastContainer, BiCheck, AiOutlineLoading3Quarters } from '../../common/common'
import MidProductAttributes from "../../middleware/Seller/Details/MidProductAttributes";
const ProductAttributes = () => {
    const { getattributes, isloggedin, isDisabled, handleSubmit, checkedIds, setCheckedIds } = MidProductAttributes();
    const handleCheckboxChange = (id) => {
        setCheckedIds((prevCheckedIds) => {
            if (prevCheckedIds.includes(id)) {
                return prevCheckedIds.filter((checkboxId) => checkboxId !== id);
            } else {
                return [...prevCheckedIds, id];
            }
        });
    };

    const ProductCategoryItem = ({ id, title, description, isChecked, onChange }) => {
        return (
            <div className="flex flex-col md:flex-row items-start gap-4 border rounded-xl shadow-sm hover:shadow-md transition-all p-4 bg-white w-full">
                {/* Checkbox */}
                <label className="relative flex-shrink-0">
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => onChange(id)}
                        className="sr-only peer"
                    />
                    <span className={`w-6 h-6 rounded-full border-2 flex items-center justify-center peer-checked:bg-green-500 peer-checked:border-green-500`}>
                        {isChecked && (
                            <svg
                                className="w-4 h-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="3"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                        )}
                    </span>
                </label>

                {/* Text Content */}
                <div className="flex flex-col">
                    <h5 className="text-base font-semibold text-gray-700">
                        {title}

                    </h5>
                    <p className="mt-1 text-md font-semibold text-teal-600">{description}</p>
                </div>

            </div>

        );
    };
    return (
        <div>
            <div className={`${styles.personalDetails} hidden lg:block lg:w-[30%] fixed h-screen overflow-y-auto scrollbar-hide`} >
                <div className="h-[100px]">
                    <div className="flex flex-row justify-center">
                        <img className="mr-0" src={Logo} width={160} height={70} alt="Dasahboard" />
                    </div>
                </div>
                <div className="mt-32">
                    <div className='relative mx-10 border-[1px] border-[#e5e5e533] border-solid rounded-xl bg-[#006e65]'>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#07ff5a] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12">

                                    <span className="text-xl sm:text-2xl px-2">
                                        <BiCheck className="text-2xl" />
                                    </span>
                                </div>
                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-60  rounded-md py-1">
                                    <h1 className="text-xl font-semibold text-white">
                                        Seller Profile Configuration
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        To establish your seller profile, please complete the designated form. You may create multiple seller profiles under the same Selzor account; however, a separate plan is required for each seller profile.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className={`${styles.animationPulse} bg-[#ffc107] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 sm:w-12 sm:h-12`}>

                                    <span className="text-xl sm:text-2xl px-2">
                                        2
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto">
                                    <h1 className="text-xl font-semibold text-white">
                                        {" "} Product Attributes {" "}
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        {" "}Select mandatory attributes (code, name, category) and choose which to display to customers while adding product data{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#686868] text-[#a0a0a0] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12 opacity-20">

                                    <span className="text-xl sm:text-2xl px-2">
                                        3
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-20">
                                    <h1 className="text-xl font-semibold text-[#a0a0a0]">
                                        {" "} Reorder Attributes {" "}
                                    </h1>
                                    <p className="text-sm font-medium text-[#a0a0a0]">
                                        {" "}Streamline product attributes to enhance clarity and facilitate informed decision-making{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#686868] text-[#a0a0a0] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12 opacity-20">

                                    <span className="text-xl sm:text-2xl px-2">
                                        4
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-20">
                                    <h1 className="text-xl font-semibold text-[#a0a0a0]">
                                        {" "}Import Product Excelsheet{" "}
                                    </h1>
                                    <p className="text-sm font-medium text-[#a0a0a0]">
                                        {" "}Easily import product information using the Excel spreadsheet to manage your inventory better{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:col-span-8 lg:ml-[30%] overflow-y-auto scrollbar-hide ">
                <div className="text-center text-blue-700 lg:hidden">
                    <div className=" w-full my-2 mx-auto p-2 flex flex-row justify-center">
                        <img src={Logo} width={160} height={70} alt="" />
                    </div>
                </div>
                <div className="max-w-full bg-white pb-10 mb-24 px-3">
                    <div className=" p-3 rounded-xl my-2 bg-[#ddfdfa]">
                        <div>
                            <h1 className="text-lg text-[#0cb1a3] font-bold"> Product Attributes </h1>
                            <p className="text-[#414747] text-sm font-medium"> Please select the appropriate attributes corresponding to your product range. The product code, name, and category are mandatory fields. You have the option to include all relevant attributes when adding product data, while selectively displaying only a subset of these attributes to your customers.</p>
                        </div>
                    </div>

                    <div className="border-[1px] border-solid border-[#dcdcdc] rounded-xl p-4 lg:p-5 w-full">
                        {/* Mandatory Fields Section */}


                        <div className="w-full max-w-5xl mx-auto p-4">
                            {/* Section Header */}
                            <div className="mb-4">
                                <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                                    Mandatory Fields
                                    <span className="text-red-600 text-2xl leading-none">*</span>
                                </h1>
                            </div>

                            {/* Grid Layout */}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

                                {/* Attribute Item */}
                                {[
                                    {
                                        title: "Product Code / Product SKU",
                                        subtitle: "(NUMERIC IDENTIFICATION CODE)",
                                        desc: 'A product code is a unique identifier used for inventory management, such as "TS001-BLU-L" for a large blue t-shirt.',
                                    },
                                    {
                                        title: "Product Name",
                                        desc: 'A product name is the distinctive title given to a specific item, like "iPhone 13 Pro Max" for Apple\'s latest smartphone model.',
                                    },
                                    {
                                        title: "Product Main Category",
                                        desc: 'A product category is a classification that groups similar items together, such as "Electronics".',
                                    },
                                    {
                                        title: "Product Short Description",
                                        desc: 'A short description is a quick summary that highlights key product features in a few sentences.',
                                    },
                                    {
                                        title: "Selling Unit",
                                        desc: 'Defines the smallest quantity in which the product is sold, e.g., "Box of 12" or "Single Piece".',
                                    },
                                    {
                                        title: "Shipping Units",
                                        desc: 'Defines the unit of measurement for shipping, e.g., "Carton", "Pallet", or "Pack of 50".',
                                    },
                                ].map((field, index) => (
                                    <div
                                        key={index}
                                        className="flex items-start gap-4 border rounded-xl shadow-sm hover:shadow-md transition-all p-2 xl:p-4 bg-white"
                                    >
                                        {/* Checkbox */}
                                        <label className="relative inline-flex items-center cursor-pointer shrink-0">
                                            <input type="checkbox" defaultChecked={true} className="sr-only" />
                                            <span className="w-6 h-6 rounded-full border-2 transition-all bg-green-500 border-green-500 flex items-center justify-center relative">
                                                <svg className="absolute top-0 left-0 w-full h-full text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                </svg>
                                            </span>
                                        </label>

                                        {/* Text Content */}
                                        <div className="flex flex-col">
                                            <h5 className="text-base font-semibold text-gray-700">
                                                {field.title}
                                                {field.subtitle && (
                                                    <span className="block text-md font-semibold text-gray-500 ">{field.subtitle}</span>
                                                )}
                                            </h5>
                                            <p className="mt-1 text-md font-semibold text-teal-600">{field.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>


                        {/* Product Category Form */}

                        <form>
                            <div className="w-full max-w-5xl mx-auto xl:p-4">
                                <div className="mb-4">
                                    <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                                        Product Attributes  (Import data for these attributes from Microsoft Excel)
                                        <span className="text-red-600 text-2xl leading-none">*</span>
                                    </h1>
                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {getattributes.map((category) => (
                                        <ProductCategoryItem
                                            key={category.id}
                                            id={category.id}
                                            title={category.attribute_name.replace(/_/g, " ")}
                                            description={category.atributes_description}
                                            isChecked={checkedIds.includes(category.id)}
                                            onChange={handleCheckboxChange}
                                        />
                                    ))}
                                </div>


                                {/* Submit Button */}
                                <div className="my-8 lg:my-12 flex justify-end">
                                    <button
                                        type="button"
                                        className="relative group px-8 lg:px-12 h-12 lg:h-14 rounded-full flex items-center bg-[#0bb29f] hover:bg-[#0aa08f] transition"
                                        onClick={handleSubmit} // always enabled now
                                    >
                                        {isloggedin ? (
                                            <span className="flex items-center text-md font-semibold text-white">
                                                <AiOutlineLoading3Quarters className="animate-spin h-5 w-5 mr-3" />
                                                Processing
                                            </span>
                                        ) : (
                                            <span className="relative text-md font-semibold text-white">
                                                Submit & Next
                                            </span>
                                        )}
                                        <div className="flex items-center h-10 lg:h-12 w-10 lg:w-12 rounded-3xl bg-[#0bb29f] group-hover:bg-[#0aa08f] absolute right-0 z-20 transition">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 lg:h-6 w-5 lg:w-6 stroke-white translate-x-2 lg:translate-x-3 transition duration-300 group-hover:translate-x-3 lg:group-hover:translate-x-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <ToastContainer />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductAttributes